import React from 'react';
import { Container } from './Container';
export function SiteFooter() {
  return <footer className="bg-navy pb-28 pt-12 text-white/70 sm:pb-12" data-id="element-162" data-mp="3r8j6h4zchgqc">
      <Container className="flex flex-col items-center gap-3 text-center text-[13px]" data-id="element-163" data-mp="3raccqj61pyxt">
        <span className="font-condensed text-2xl font-extrabold uppercase text-white" data-id="element-164" data-mp="3mfq24i7sgaes">School Counselor Ready Hub</span>
        <p data-id="element-165" data-mp="3hglqzm1b02lt">Digital educational resources in English · Single-counselor license.</p>
        <p data-id="element-166" data-mp="3di5umrjc1hvq">Support contact details are provided with your order.</p>
        <p className="text-white/50" data-id="element-167" data-mp="38gq9z0l2hddv">© 2026 School Counselor Ready Hub. All rights reserved.</p>
      </Container>
    </footer>;
}